import { initializeApp } from 'firebase/app'
import { getFirestore , doc, deleteDoc, orderBy,  limit ,updateDoc, increment, documentId,setDoc ,query, where, collection, getDocs} from 'firebase/firestore'
import { getAuth ,signOut ,deleteUser , updatePassword , sendPasswordResetEmail, createUserWithEmailAndPassword } from 'firebase/auth'
import {getStorage , deleteObject,ref , uploadBytes, getDownloadURL,} from 'firebase/storage'
import Papa from 'papaparse';
// const months = ["มค/Jan","กพ/Feb","มีค/Mar","เมษ/Apr","พค/May","มิย/Jun","กค/Jul","สค/Aug","กย/Sep","ตค/Oct","พย/Nov","ธค/Dec"]
const months = ["01","02","03","04","05","06","07","08","09","10","11","12"]
// const firebaseConfig = {
//   apiKey: 'AIzaSyCfCvlxaHmg3YgR07aJlw0pUiokj2Y7srw',
//   authDomain: 'conex-a535b.firebaseapp.com',
//   projectId: 'conex-a535b',
//   storageBucket: 'conex-a535b.appspot.com',
//   messagingSenderId: '954213072224',
//   appId: '1:954213072224:web:5405ee241c20bbd844b205'
// };
const firebaseConfig = {
  apiKey: 'AIzaSyCfCvlxaHmg3YgR07aJlw0pUiokj2Y7srw',
  authDomain: 'conex-a535b.web.app',
  projectId: 'conex-a535b',
  storageBucket: 'conex-a535b.appspot.com',
  messagingSenderId: '954213072224',
  appId: '1:954213072224:web:5405ee241c20bbd844b205'
};
const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)
export const authUser = getAuth(app)
export const storage = getStorage(app)
export const googleMapApiKey= 'AIzaSyChfMusRyXTeN11PyREyY2p_P8LaONJFDo'  // project id : conex-a535b
// export const googleMapApiKey= 'AIzaSyCd-qv9-Wciodcem4bRrB8TIxSJtREi3W0'  // project id : conex-432423
export { signOut , createUserWithEmailAndPassword }
export const activeListByCompId = async(coll, compId, cb)=>{
  const q = query(collection(db, coll), 
    where("compId", "==", compId),
    where("active", "==", true)
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data()
  });
  cb(list)
}

export const getData = async(coll, fieldName, fieldData , cb)=>{
  const q = query(collection(db, coll), 
    where(fieldName, "==", fieldData),
  );
  const querySnapshot = await getDocs(q);
  const d = querySnapshot.docs.map((doc) => {
    return doc.data()
  });
  cb (d)
}
export const cvf2USD = (exRate, curr) =>{
  let cv
    switch (curr) {
      case 'USD':
        cv= 1
        break;
      case 'AUD':
        cv= 1 / exRate.AUD
        break;
      case 'CAD':
        cv= 1 / exRate.CAD
        break;
      case 'CNY':
        cv= 1 / exRate.CNY
        break;
      case 'EUR':
        cv= 1 / exRate.EUR
        break;
      case 'GBP':
        cv= 1 / exRate.GBP
        break;
      case 'JPY':
        cv= 1 / exRate.JPY
        break;
      case 'THB':
        cv= 1 / exRate.THB
        break;
      default:
        break;
    }
  return  parseFloat(cv).toFixed(4)
} 
// export const getSrvScpArrByCntry = async(cntryCode, cb)=>{
//   const q = query(collection(db,'Country'), 
//     where('id', "==", cntryCode),
//   );
//   const querySnapshot = await getDocs(q);
//   const d = querySnapshot.docs.map((doc) => {
//     return doc.data().srvScp
//   });
//   const qp = query(collection(db, 'Port'),
//   where('cntryCode', "==", cntryCode),
//   );
//   const querySnapshotP = await getDocs(qp);
//   const p = querySnapshotP.docs.map((doc) => {
//   let dd= doc.data()
//   return `${dd.pName.trim()}-${dd.id}`
//   });
//   cb (p.concat(d[0].split(',')))
// }
export const getSrvScpArrByCntry = async(cntryCode, cb)=>{
  const q = query(collection(db,'Country'), 
    where('id', "==", cntryCode),
  );
  const querySnapshot = await getDocs(q);
  const d = querySnapshot.docs.map((doc) => {
    return doc.data().srvScp
  });
  cb (d[0].split(','))
}
export const getPortNameCode = async(portCode)=>{
  const q = query(collection(db, 'Port'),
  where('id', "==", portCode),
  );
  const querySnapshot = await getDocs(q);
  const dd = querySnapshot.docs.map((doc) => {
    let d= doc.data()
    return `${d.pName.trim()}-${d.id}`
  });
  return dd[0]
}
export const getSrvScpList = async(cb)=>{
  const q = query(collection(db, 'SrvScp')
  );
  const querySnapshot = await getDocs(q);
  const d = querySnapshot.docs.map((doc) => {
    return doc.data().srvScp
  });
  const qp = query(collection(db, 'Port'),
      // orderBy("pName" , "asc"),
  );
  const querySnapshotP = await getDocs(qp);
  const p = querySnapshotP.docs.map((doc) => {
    let dd= doc.data()
    return `${dd.pName.trim()}-${dd.id}`
  });
  let uniArr = d.concat(p).filter((item, index, self)=>{
    return self.indexOf(item) === index
})
  cb (uniArr.sort())
  // cb (d.concat(p))
}
export const getFghtRateByPOD = async(POD, shipDateReqr, duoFghtCtcArr, cb)=>{
  let sdrTS = Date.parse(shipDateReqr)
  const q = query(collection(db, 'FreightRate'), 
    where('POD', "==", POD),
    where('compId', "in", duoFghtCtcArr),
    where('effDateTS', "<=", sdrTS),
    where('expDateTS', ">=", sdrTS),
  );
  const querySnapshot = await getDocs(q);
  const d = querySnapshot.docs.map((doc) => {
    return doc.data()
  });
  cb (d)
}
export const getFghtRates = async(compId, agent, cb)=>{
  const q = query(collection(db, 'FreightRate'), 
    where('compId', "==", compId),
    where('agent', "==", agent),
  );
  const querySnapshot = await getDocs(q);
  const d = querySnapshot.docs.map((doc) => {
    return doc.data()
  });
  cb (d)
}
export const getSurchargeByArrs = async(agentArr, polArr, srvScpArr, contTypeArr, shipDateReqr, cb)=>{
  let sdrTS = Date.parse(shipDateReqr)
  const q = query(collection(db, 'Surcharge'), 
    where('agent', "in", agentArr),
    where('appnEx', "in", polArr),
    // where('appnTo', "in", srvScpArr),
    where('contType', "in", contTypeArr),
    where('effDateTS', "<=", sdrTS),
    where('expDateTS', ">=", sdrTS),
  );
  const querySnapshot = await getDocs(q);
  const d = querySnapshot.docs.map((doc) => {
    return doc.data()
  });
  const a = d.filter((i)=>{
    if (srvScpArr.includes(i.appnTo)) {
      return(i)
    }
  })
  cb (a)
}
export const getCntryList = async( cb )=>{
  const q = query(collection(db, "Country"),
  orderBy("cntry" , "asc")
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      text : d.cntry,
      value : d.id
    }
  });
  cb (list)
}
export const getCntryByCode = async(code , cb)=>{
  const q = query(collection(db, "Country"),
  where('id', "==", code),
  );

  const querySnapshot = await getDocs(q);
  const cntry = querySnapshot.docs.map((doc) => {
    return {
      cntry : doc.data().cntry}
  });
  cb(cntry[0])
}
export const getPortExitList = async( cntryCode , cb)=>{
  let portExitList = [{
    text : "All Ports of Loading",
    value : "ALL"  
  }]
  const q = query(collection(db, "Port"), 
    where('cntryCode', "==", cntryCode),
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      text : `${d.pName.trim()}-${d.id}`,
      value : d.id
    }
  });
  let exList = portExitList.concat(list)
  // console.log(`PortList = ${JSON.stringify(exList, null, 2)}`)
  // console.log(`PortEx = ${JSON.stringify(portEx, null, 2)}`)
  
  cb (exList)
}
export const getPortList = async( cntryCode , cb)=>{
  const q = query(collection(db, "Port"), 
    where('cntryCode', "==", cntryCode),
    // orderBy("pName" , "asc"),
    // limit(3)
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      text : `${d.pName.trim()}-${d.id}`,
      value : d.id
    }
  });
  cb (list)
}
export const getPortListByPortArr = async( portArr, cb)=>{
  const q = query(collection(db, "Port"), 
    where('id', "in", portArr),
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      text : `${d.pName.trim()}-${d.id}`,
      value : d.id
    }
  });
  cb (list)
}
export const getAllPortsList = async( cb)=>{
  const q = query(collection(db, "Port"), 
  orderBy("pName" , "asc")
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      value : d.id,   
      text : `${d.pName.trim()}-${d.id}`
    }
  });
  cb (list)
}
export const vSelectObjPort = async(id)=>{
  const q = query(collection(db, coll), 
  where('id', "==", id),
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      value : d.id,   
      text : `${d.pName.trim()}-${d.id}`
    }
  });
  return list[0]
}
export const getAllSurCodeList = async( cb)=>{
  const q = query(collection(db, "SurCode"), 
  orderBy("surDesc" , "asc")
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      text : `${d.surDesc}-${d.id}`,
      value : d.id
    }
  });
  cb (list)
}
export const getHS6List = async( cb)=>{
  const querySnapshot = await getDocs(collection(db, "HSex"));
  const list = querySnapshot.docs.map((doc) => {
    return doc.data().id 
  });
  let l = list.filter( i => i.length >= 7 && !i.endsWith('-')
   )
  cb (l)
}
export const getDataWithinDays = async(coll, fieldName, fieldData, days , cb)=>{
  let limit = new Date().valueOf() - (days*86400000)
  const q = query(collection(db, coll), 
    where(fieldName, "==", fieldData),
    where('timestamp', ">=", limit),
  );
  const querySnapshot = await getDocs(q);
  const d = querySnapshot.docs.map((doc) => {
    return doc.data()
  });
  cb (d)
}
export const getDocId = async(coll, fieldName, fieldData , cb)=>{
  const q = query(collection(db, coll), 
    where(fieldName, "==", fieldData),
  );
  const querySnapshot = await getDocs(q);
  const d = querySnapshot.docs.map((doc) => {
    return doc.id
  });
  cb (d)
}

export const truckListAccept = async( compId, cb)=>{
  let tmrTS = new Date().valueOf() + 86400000
  let list = []
  const q = query(collection(db, 'Truck'), 
    where('compId', "==", compId),
    where("active", "==", true),  
  );
  const querySnapshot = await getDocs(q);
  querySnapshot.docs.map((doc) => {
    let d = doc.data()
    if (d.registExpiryDate > tmrTS && d.insurExpiryDate > tmrTS ) {
      list.push({
        value : d.licensePlate,
        text : `${d.licensePlate} /Expiry:${new Date(d.registExpiryDate).getDate()}-${months[new Date(d.registExpiryDate).getMonth()]}-${new Date(d.registExpiryDate).getFullYear()+543} /Insurance:${new Date(d.insurExpiryDate).getDate()}-${months[new Date(d.insurExpiryDate).getMonth()]}-${new Date(d.insurExpiryDate).getFullYear()+543}`
      }) 
    }
  });
  cb (list)
}
// export const truckListAccept = async( compId, cb)=>{
//   let tmrTS = new Date().valueOf() + 86400000
//   const q = query(collection(db, 'Truck'), 
//     // where('compId', "==", compId),
//     // where("active", "==", true)    
//     where('registExpiryDate', ">", tmrTS),
//     // where('insurExpiryDate', ">", tmrTS),
//   );
//   const querySnapshot = await getDocs(q);
//   const list = querySnapshot.docs.map((doc) => {
//     let d = doc.data()
//     return {
//       value : d.licensePlate,
//       text : `${d.licensePlate} /Expiry:${new Date(d.registExpiryDate).getDate()}-${months[new Date(d.registExpiryDate).getMonth()]}-${new Date(d.registExpiryDate).getFullYear()+543} /Insurance:${new Date(d.insurExpiryDate).getDate()}-${months[new Date(d.insurExpiryDate).getMonth()]}-${new Date(d.insurExpiryDate).getFullYear()+543}`
//     }
//   });
//   cb (list)
// }
// export const driverListAccept = async( compId, cb)=>{
//   let tmrTS = new Date().valueOf() + 86400000
//   const q = query(collection(db, 'Driver'), 
//     where('compId', '==', compId),
//     // where('licenseExpiryDate', '>=', tmrTS),
//     where('active', '==', true)
//   );
//   const querySnapshot = await getDocs(q);
//   const list = querySnapshot.docs.map((doc) => {
//     let d = doc.data()
//     return {
//       value : d.driverId,
//       text : `${d.name} /Expiry:${new Date(d.licenseExpiryDate).getDate()}-${months[new Date(d.licenseExpiryDate).getMonth()]}-${new Date(d.licenseExpiryDate).getFullYear()+543}`
//     }
//   });
//   cb (list)
// }
export const driverListAccept = async( compId, cb)=>{
  let tmrTS = new Date().valueOf() + 86400000
  let list = []
  const q = query(collection(db, 'Driver'), 
    where('compId', '==', compId),
    where('active', '==', true)
  );
  const querySnapshot = await getDocs(q);
  querySnapshot.docs.forEach((doc) => {
    let d = doc.data()
    if (d.licenseExpiryDate > tmrTS) {
      getData('Users' , 'userId', d.driverId, (res)=>{
      list.push({
          value : d.driverId,
          text : `${res[0].name} /Expiry:${new Date(d.licenseExpiryDate).getDate()}-${months[new Date(d.licenseExpiryDate).getMonth()]}-${new Date(d.licenseExpiryDate).getFullYear()+543} /MB: ${res[0].phone}`
        })
      })
 
    }
  });
  cb (list)
}

export const agentAtBkgId = async(bkgId, compId, cb)=>{
  const q = query(collection(db, "BookingID"), 
    where("bkgId", "==", bkgId),
    where("compId", "==", compId)
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data().agent
  });
  cb(list[0])
}
export const agentAtCompId = async(compId, cb)=>{
  const q = query(collection(db, "Company"), 
    where("compId", "==", compId)
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data().compNameEng
  });
  cb(list[0])
}

export const agentAtContId = async(contId, cb)=>{
  const q = query(collection(db, "Container"), 
    where("contId", "==", contId)
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d=doc.data()
    return {
      contId: d.contId,
      contNo : d.contNo,
      agent : d.owner,
      contType : d.contType,
      contSize : d.contSize,
      contGrade : d.contGrade,
      detDate: d.detDate,
      detTS: d.detTS,
      // imageUri : d.imageUri, * cancel imageUri at Release
      maxGross : d.maxGross,
      tare : d.tare
    }
  });
  cb(list[0])
}
export const agentList = async(cb)=>{
  const q = query(collection(db, "Company"), 
    where("active", "==", true),
    where("busType", "==", "agent"))
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data().compNameEng
  });
  cb(list)
}
export const bkgFileUri = async(bkgId , compId)=>{
  const q = query(collection(db, "BookingID"), 
    where("bkgId", "==", bkgId),
    where("compId", "==", compId),
  );
  const querySnapshot = await getDocs(q);
  const uri = querySnapshot.docs.map((doc) => {
    return doc.data().fileUri
  });
  return uri[0]
}
export const bkgIdList = async(compId, cb)=>{
  const q = query(collection(db, "BookingID"), 
    where("compId", "==", compId),
    where("active", "==", true)
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data().bkgId 
  });
  cb(list)
}
export const bkgIdListAgentGroup = async(compId, agent, curBkgId, cb)=>{
  await getAgentGroup(agent, async(agentGroup)=>{
    if (agentGroup == undefined) {
      cb([])
    } else {
      let list = []
      const q = query(collection(db, "BookingID"), 
        where("active", "==", true),
        where("compId", "==", compId),
        where("bkgId", "!=", curBkgId)
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.docs.forEach((doc) => {
        let d = doc.data()
        if (agentGroup.includes(d.agent)){
          list.push(d.bkgId)
        }
      });
      cb(list)      
    }
  })
}
export const bkgIdListAll = async( compId , cb)=>{
  const q = query(collection(db, "BookingID"), 
    // where("active", "==", true),
    where("compId", "==", compId)
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data()
  });
  cb(list)
}
export const billInternal = async(compId, startAt, endAt, cb)=>{
  const q = query(collection(db, "MatchTx"),
    where('stepNo', 'in', [ 4, 4.1, 4.2]), 
    where('txSearcher', '==', "Reuse"), 
    where('compIdRels', '==', compId),  
    where('timestamp', '>=' , startAt),  
    where('timestamp', '<=' , endAt),  
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()

    return {
      mTxId: d.mTxId,
      timestamp: d.timestamp, 
      date: new Date(d.timestamp),
      jobMethCat : `${d.txSearcher}-Internal`,
      bkgId: d.bkgId, 
      sealNo: d.sealNo, 
      contNo: d.contNo,            
      contType: d.contType,
      contSize: d.contSize,
      contGrade: d.contGrade,
      agent: d.agent,                
      company_Giver: d.compNameLocalRels,               
      address_Giver: d.contRelsAddress,          
      company_Receiver: d.compNameLocalReqr,                
      address_Receiver: d.contReqrAddress,
      amount: 900
    }
  });
  cb(list)
}
export const billInternalAdmin = async( startAt, endAt, cb)=>{
  const q = query(collection(db, "MatchTx"),
    where('stepNo', 'in', [ 4, 4.1, 4.2]), 
    where('txSearcher', '==', "Reuse"), 
    // where('compIdRels', '==', compId),  
    where('timestamp', '>=' , startAt),  
    where('timestamp', '<=' , endAt),  
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()

    return {
      mTxId: d.mTxId,
      timestamp: d.timestamp, 
      date: new Date(d.timestamp),
      jobMethCat : `${d.txSearcher}-Internal`,
      bkgId: d.bkgId, 
      sealNo: d.sealNo, 
      contNo: d.contNo,            
      contType: d.contType,
      contSize: d.contSize,
      contGrade: d.contGrade,
      agent: d.agent,                
      company_Giver: d.compNameLocalRels,               
      address_Giver: d.contRelsAddress,          
      company_Receiver: d.compNameLocalReqr,                
      address_Receiver: d.contReqrAddress,
      amount: 900
    }
  });
  cb(list)
}
export const billPropsr = async(compId, startAt, endAt, cb)=>{
  const q = query(collection(db, "MatchTx"),
    where('stepNo', 'in', [ 4, 4.1, 4.2]), 
    where('txSearcher', 'in', ["Require", "Release"]), 
    where('compIdRels', '==', compId),  
    where('timestamp', '>=' , startAt),  
    where('timestamp', '<=' , endAt),  
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      mTxId: d.mTxId,
      timestamp: d.timestamp,
      date: new Date(d.timestamp),
      jobMethCat : `${d.txSearcher}-Proposer`,
      bkgId: d.bkgId, 
      sealNo: d.sealNo, 
      contNo: d.contNo,            
      contType: d.contType,
      contSize: d.contSize,
      contGrade: d.contGrade,
      agent: d.agent,                
      company_Giver: d.compNameLocalRels,               
      address_Giver: d.contRelsAddress,          
      company_Receiver: d.compNameLocalReqr,                
      address_Receiver: d.contReqrAddress,
      amount: 450
    }
  });
  cb(list)
}
export const billPropsrAdmin = async( startAt, endAt, cb)=>{
  const q = query(collection(db, "MatchTx"),
    where('stepNo', 'in', [ 4, 4.1, 4.2]), 
    where('txSearcher', 'in', ["Require", "Release"]), 
    // where('compIdRels', '==', compId),  
    where('timestamp', '>=' , startAt),  
    where('timestamp', '<=' , endAt),  
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      mTxId: d.mTxId,
      timestamp: d.timestamp,
      date: new Date(d.timestamp),
      jobMethCat : `${d.txSearcher}-Proposer`,
      bkgId: d.bkgId, 
      sealNo: d.sealNo, 
      contNo: d.contNo,            
      contType: d.contType,
      contSize: d.contSize,
      contGrade: d.contGrade,
      agent: d.agent,                
      company_Giver: d.compNameLocalRels,               
      address_Giver: d.contRelsAddress,          
      company_Receiver: d.compNameLocalReqr,                
      address_Receiver: d.contReqrAddress,
      amount: 450
    }
  });
  cb(list)
}
export const billRecvr = async(compId, startAt, endAt, cb)=>{
  const q = query(collection(db, "MatchTx"),
    where('stepNo', 'in', [ 4, 4.1, 4.2]), 
    where('txSearcher', 'in', ["Require", "Release"]), 
    where('compIdReqr', '==', compId),  
    where('timestamp', '>=' , startAt),  
    where('timestamp', '<=' , endAt),  
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      mTxId: d.mTxId,
      timestamp: d.timestamp,
      date: new Date(d.timestamp),
      jobMethCat : `${d.txSearcher}-Receiver`,
      bkgId: d.bkgId, 
      sealNo: d.sealNo, 
      contNo: d.contNo,            
      contType: d.contType,
      contSize: d.contSize,
      contGrade: d.contGrade,
      agent: d.agent,                
      company_Giver: d.compNameLocalRels,               
      address_Giver: d.contRelsAddress,          
      company_Receiver: d.compNameLocalReqr,                
      address_Receiver: d.contReqrAddress,
      amount: 450
    }
  });
  cb(list)
}
export const billRecvrAdmin = async( startAt, endAt, cb)=>{
  const q = query(collection(db, "MatchTx"),
    where('stepNo', 'in', [ 4, 4.1, 4.2]), 
    where('txSearcher', 'in', ["Require", "Release"]), 
    // where('compIdReqr', '==', compId),  
    where('timestamp', '>=' , startAt),  
    where('timestamp', '<=' , endAt),  
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      mTxId: d.mTxId,
      timestamp: d.timestamp,
      date: new Date(d.timestamp),
      jobMethCat : `${d.txSearcher}-Receiver`,
      bkgId: d.bkgId, 
      sealNo: d.sealNo, 
      contNo: d.contNo,            
      contType: d.contType,
      contSize: d.contSize,
      contGrade: d.contGrade,
      agent: d.agent,                
      company_Giver: d.compNameLocalRels,               
      address_Giver: d.contRelsAddress,          
      company_Receiver: d.compNameLocalReqr,                
      address_Receiver: d.contReqrAddress,
      amount: 450
    }
  });
  cb(list)
}
export const billTransfer = async(compId, startAt, endAt, cb)=>{
  const q = query(collection(db, "MatchTx"),
    where('stepNo', 'in', [ 4, 4.1, 4.2]), 
    where('txSearcher', '==', "Transfer"), 
    where('compIdReqr', '==', compId),  
    where('timestamp', '>=' , startAt),  
    where('timestamp', '<=' , endAt),  
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()

    return {
      mTxId: d.mTxId,
      timestamp: d.timestamp, 
      date: new Date(d.timestamp),
      jobMethCat : "Transfer",
      bkgId: d.bkgId, 
      sealNo: d.sealNo, 
      contNo: d.contNo,            
      contType: d.contType,
      contSize: d.contSize,
      contGrade: d.contGrade,
      agent: d.agent,                
      company_Giver: d.compNameLocalRels,               
      address_Giver: d.contRelsAddress,          
      company_Receiver: d.compNameLocalReqr,                
      address_Receiver: d.contReqrAddress,
      amount: 100
    }
  });
  cb(list)
}
export const billTransferAdmin = async( startAt, endAt, cb)=>{
  const q = query(collection(db, "MatchTx"),
    where('stepNo', 'in', [ 4, 4.1, 4.2]), 
    where('txSearcher', '==', "Transfer"), 
    // where('compIdReqr', '==', compId),  
    where('timestamp', '>=' , startAt),  
    where('timestamp', '<=' , endAt),  
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()

    return {
      mTxId: d.mTxId,
      timestamp: d.timestamp, 
      date: new Date(d.timestamp),
      jobMethCat : "Transfer",
      bkgId: d.bkgId, 
      sealNo: d.sealNo, 
      contNo: d.contNo,            
      contType: d.contType,
      contSize: d.contSize,
      contGrade: d.contGrade,
      agent: d.agent,                
      company_Giver: d.compNameLocalRels,               
      address_Giver: d.contRelsAddress,          
      company_Receiver: d.compNameLocalReqr,                
      address_Receiver: d.contReqrAddress,
      amount: 100
    }
  });
  cb(list)
}
export const changeName = async(userId ,name , cb)=>{
  await updateDoc(doc(db, "Users", userId), { name: name}).then(()=>{
    cb ("success")
  }).catch((err)=>{
    cb ("failed")
  })
}
export const changePassword = async(password , cb)=>{ 
  await updatePassword(authUser.currentUser, password).then(() => {
    cb( "success")
  }).catch((err) => {
    console.log(`changePassword error : !${err}`)
    cb ("failed")
  });
}
export const changePhone = async(userId ,phone, cb)=>{
  await updateDoc(doc(db, "Users", userId), { phone: phone}).then(()=>{
    cb ("success")
  }).catch((err)=>{
    cb ("failed")
  })
}
export const contAgent = async(contId, cb)=>{
  const q = query(collection(db, "Container"), 
    where("contId", "==", contId)
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data().owner
  });
  cb(list[0])
}
export const compIdByCompName = async(nameLocal, cb)=>{
  const q = query(collection(db, "Company"), 
    where("active", "==", true),
    where("compNameLocal", "==", nameLocal)
  );
  const querySnapshot = await getDocs(q);
  const compId = querySnapshot.docs.map((doc) => {
      return  doc.data().compId
  });
  cb(compId[0])
}

export const compInfo = async(compId, cb)=>{
  const q = query(collection(db, "Company"), 
    where("active", "==", true),
    where("compId", "==", compId)
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
      return  doc.data()
  });
  cb(list[0])
}

// export const compListAll = async(cb)=>{
//   const q = query(collection(db, "Company")
//   );
//   const querySnapshot = await getDocs(q);
//   const list = querySnapshot.docs.map((doc) => {
//     return doc.data()
//   });
//   cb(list)
// }
export const getDataAll = async( coll, cb)=>{
  const q = query(collection(db, coll)
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data()
  });
  cb(list)
}
export const getDataHS = async( coll, cb)=>{
  const q = query(collection(db, coll)
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      mn : d.id.slice(0,2),
      id : d.id,
      dTH : d.dTH,
      dEN : d.dEN
    }
  });
  cb(list)
}
export const compListAllRefill = async(cb)=>{
  const q = query(collection(db, "Company"),
  where("active", "==", true),
  where("busType", "==", "logist"),
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data()
  });
  cb(list)
}
export const compNameLocalByCompId = async(compId)=>{
  const q = query(collection(db, "Company"), 
    where("active", "==", true),
    where("compId", "==", compId)
  );
  const querySnapshot = await getDocs(q);
  const compNameLocal = querySnapshot.docs.map((doc) => {
      return  doc.data().compNameLocal
  });
  return compNameLocal[0]
}
export const compNameEngByCompId = async(compId , cb)=>{
  const q = query(collection(db, "Company"), 
    where("active", "==", true),
    where("compId", "==", compId)
  );
  const querySnapshot = await getDocs(q);
  const compNameEng = querySnapshot.docs.map((doc) => {
      return  doc.data().compNameEng
  });
  cb (compNameEng[0])
}
// export const compNameList = async(busType, cb)=>{
//   if (busType == 'agent') {
//     const q = query(collection(db, "Company"), 
//       where("active", "==", true),
//       where("busType", "==", 'agent'),
//     );
//     const querySnapshot = await getDocs(q);
//     const list = querySnapshot.docs.map((doc) => {
//       return  doc.data().compNameLocal
//     });
//     cb(list)
//   } else {
//     const q = query(collection(db, "Company"), 
//     where("active", "==", true),
//     where("busType", "!=", 'agent'),
//   );
//     const querySnapshot = await getDocs(q);
//     const list = querySnapshot.docs.map((doc) => {
//       return  doc.data().compNameLocal
//     });
//     cb(list)
//   }
// }

export const compNameList = async(opt, cb)=>{
  const q = query(collection(db, "Company"), 
    where("active", "==", true),
    where("busType", `${opt}`, 'agent'),
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return  doc.data().compNameLocal
  });
  cb(list)
}
export const compNameListLogist = async(cb)=>{
  const q = query(collection(db, "Company"), 
    where("active", "==", true),
    where("busType", "==", "logist"),
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
      return  doc.data().compNameLocal
  });
  cb(list)
}
// export const contList = async(compId, cb)=>{
//   let todayTS = Date.parse(new Date())
//   let list = []
//   const q = query(collection(db, "Container"), 
//     where('active', '==', true),
//     // where('detTS', '>=', todayTS),       
//     where('compId', '==', compId)
//   );
//   const querySnapshot = await getDocs(q);
//   querySnapshot.docs.forEach((doc) => {
//     let d = doc.data()
//     if ((d.detTS >= todayTS) && (d.contGrade != '') && (d.detDate != '') && (d.maxGross != '') && (d.maxGross != '') &&  (d.imageUri != '') ) {
//       list.push({
//         value: d.contId , 
//         text : `${d.contNo}: ${d.contType}-${d.contSize}-Grade# ${d.contGrade}`
//       })
//     }
//   });
//   cb(list)
// }
export const contIdList = async(compId, cb)=>{
  let todayTS = Date.parse(new Date())
  let list = []
  const q = query(collection(db, "Container"), 
    where('active', '==', true),
    // where('detTS', '>=', todayTS),       
    where('compId', '==', compId)
  );
  const querySnapshot = await getDocs(q);
  querySnapshot.docs.forEach((doc) => {
    let d = doc.data()
    if (doc.exists()) {
      if ((d.detTS >= todayTS) && (d.detDate != '')) {
        list.push({
          value: d.contId , 
          text : `${d.contNo}: ${d.contType}-${d.contSize}-Grade# ${d.contGrade}`
        })
      }      
    }
  });
  cb(list)
}
export const contListAgentGroup = async(compId, agent, cb)=>{
  await getAgentGroup(agent, async(agentGroup)=>{
    if (agentGroup == undefined) {
      cb([])
    } else {
      let list = []
      const q = query(collection(db, "Container"), 
        where("active", "==", true),
        where("compId", "==", compId)
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.docs.forEach((doc) => {
        let d = doc.data()
        if (agentGroup.includes(d.owner) && (d.contGrade != '') && (d.detDate != '') && (d.maxGross != '') && (d.maxGross != '')){
          // list.push(d.contId)
          list.push({
            value: d.contId , 
            text : `${d.contNo}: ${d.contType}-${d.contSize}-Grade# ${d.contGrade}`
          })
        }
      });
      cb(list)      
    }
  })
}
export const contListAgentNoDet = async(agent, cb)=>{
  const q = query(collection(db, "Container"), 
    where("active", "==", true),
    where("owner", "==", agent),
    where("detDate", "==", ""),
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      contId : d.contId,
      contNo : d.contNo,
      contType : d.contType,
      contSize : d.contSize,
      owner : d.owner,
      detDate : d.detDate
    }
  });
  cb(list)
}
export const contListAgentDet = async(agent, cb)=>{
  const q = query(collection(db, "Container"), 
    where("active", "==", true),
    where("owner", "==", agent),
    where("detDate", "!=", ""),
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
      return {
        contId : d.contId,
        contNo : d.contNo,
        contType : d.contType,
        contSize : d.contSize,
        owner : d.owner,
        detDate : d.detDate,
        timestamp : d.timestamp
      }
  });
  cb(list)
}
export const contListAll = async(compId, active, cb)=>{
  const q = query(collection(db, "Container"), 
    where("active", "==", active),
    where("compId", "==", compId)
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data()
  });
  cb(list)
}
// export const transCompList1 = async(compId, cb)=>{
//   let list = [
//     {compId : compId, transName : "หัวรถบริษัทของคุณ / Company Track"} 
//   ]
//   const q = query(collection(db, "Company"), 
//     where("active", "==", true),
//     where("busType", "==", "trans"),
//   );
//   const querySnapshot = await getDocs(q);
//   querySnapshot.docs.forEach((doc) => {
//     let d = doc.data()
//       list.push({compId : d.compId, transName : d.compNameLocal})
//   });
//   cb(list)
// }

export const chartDataType = async(compId, compAct,txSearcher,startAt, cb)=>{
  const q = query(collection(db, "MatchTx"),
    where('stepNo', 'in', [4 , 4.1, 4.2]), 
    where('txSearcher', 'in', txSearcher), 
    where(`${compAct}`, '==', compId),  
    where('timestamp', '>=' , startAt), 
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    if (d.length > 0 ) {
         let mm = new Date(d.timestamp).getMonth() + 1
    let MM = mm < 10 ?  `0${mm}` : mm.toString()
    let yyyy = new Date(d.timestamp).getFullYear()
     return parseInt( yyyy+MM) 
    } 
  });
  cb(list)
}
export const deleteAccount = async(userId, cb)=>{   
  await updateActive("Users", userId, false).then(async()=>{
    await deleteUser(authUser.currentUser).then(() => {
      cb ("success")
    }).catch((err)=>{
      console.log(`updateUsersActive to False, error : !${err}`)
      cb ("failed")
    })
  }).catch((err) => {
    console.log(`deleteUser error : !${err}`)
    cb ("failed")
  });
}
export const deleteImageUrl = async( bucket, existImageUri)=>{
  const existFileName = existImageUri.substring(existImageUri.lastIndexOf('%2F')+3, existImageUri.lastIndexOf('?')) //  คัดชื่อไฟล์ออกมา
  console.log(' existFileName=>'+existFileName)
  const desertRef =ref(storage,`${bucket}/${existFileName}`)
  deleteObject(desertRef).then(()=>{
      console.log(' File deleted successfully=>'+existImageUri)
  }).catch ((error)=>(
      console.log('an error(deleteObject) occurred')
  ))
}
export const deleteItem = async( coltn, id)=>{
  await deleteDoc(doc(db, coltn, id))
}
export const dowmloadFile = async( bucket, fileURL , cb)=>{
  const file = await getPictureBlob(fileURL.url)
  const storageRef = ref(storage, `${bucket}/${fileURL.name}`)
    // console.log(`snapshot => ${JSON.stringify(snapshot , null ,2)}`)
    await getDownloadURL(storageRef)
    .then((url)=>{
      cb(url)
    })

}
const getAgentGroup = async( agent, cb)=>{
  const q = query(collection(db, "AgentGroup"), 
    where("agent", "==", agent),
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data().group
  });
  cb(list[0])
}
export const getBalance =async(compId, callback)=>{
  const q = query(collection(db,'Wallet'), where ("compId", "==", compId))
  const walletQuerySnapshot = await getDocs(q) 
  const bal = walletQuerySnapshot.docs.map((doc) => {
      return doc.data().balanced                       
  })  
  callback(bal[0])   
}

const getPictureBlob = (uri) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = function () {
      resolve(xhr.response);
    };
    xhr.onerror = function (e) {
      console.log(e);
      reject(new TypeError('Network request failed'));
    };
    xhr.responseType = 'blob';
    xhr.open('GET', uri, true);
    xhr.send(null);
  });
}
export const getNameCompId= async( compId )=>{
  const q = query(collection(db, "Company"), 
    where(documentId(), "==", compId)
  );
  const querySnapshot = await getDocs(q);
  const name = querySnapshot.docs.map((doc) => {
    return doc.data().compNameLocal
  });
  return name[0]
}
export const getRefillSlip = async( startAt, endAt, cb)=>{
  let rData = []
  const q = query(collection(db, "uaTx"),
    where('timestamp', '>=' , startAt),  
    where('timestamp', '<=' , endAt),
    where("acctType", "in", ["refillCC" , "refill" ,"adjust" , "refillOL"])
  );
  const querySnapshot = await getDocs(q);
  querySnapshot.docs.forEach((doc) => {
    let d = doc.data()
    console.log(`d=> ${JSON.stringify(d)}`)
    rData.push({
      date : new Date(d.timestamp),
      // compNameLocal : await getNameCompId(d.payerId),  // this call is not work
      ...d
    })
  })
  cb(rData)
}

export const getStatusByDocId = async(collectionName, docId, cb)=>{
  const q = query(collection(db, collectionName),
    where(documentId(), "==", docId)
  );
  const querySnapshot = await getDocs(q);
  const status = querySnapshot.docs.map((doc) => {
      return doc.data().status
  });
  cb(status[0])
}
export const getWalletData = async( cb)=>{
  let wData = []
  const querySnapshot = await getDocs(collection(db, "Wallet"));
  querySnapshot.forEach(async(doc) => {
    let d = doc.data()
    wData.push({
      compNameLocal : await getNameCompId(d.compId),
      ...d
    })
  });
  cb(wData)
}

export const locByCompId = async(compId, cb)=>{
  const q = query(collection(db, "Company"), 
    where("active", "==", true),
    where("compId", "==", compId)
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d=doc.data()
      return  {
        compLoc : d.compLoc,
        compAddress : d.compAddress
      }
  });
  cb(list[0])
}
// export const matchTxsReqr = async(compId, cb)=>{
//   let lastWeek = Date.parse(new Date())-658800000
//   let list = []
//   const q = query(collection(db, "MatchTx"),
//     // where('detTS', '>=' , now),  
//     where('active', '==', true), 
//     where('compIdReqr', '==', compId),


//   );
//   const querySnapshot = await getDocs(q);
//   querySnapshot.docs.forEach((doc) => {
//     let data = doc.data()
//     if (data.detTS >= lastWeek) {
//       list.push(data)
//     }
//   });
//   cb(list)
// }
// export const matchTxsRels = async(compId, cb)=>{
//   let lastWeek = Date.parse(new Date())-658800000
//   let list = []
//   const q = query(collection(db, "MatchTx"),
//     //  where('detTS', '>=' , now),  
//     where('active', '==', true),
//     where('compIdRels', '==', compId),
//   );
//   const querySnapshot = await getDocs(q);
//   querySnapshot.docs.forEach((doc) => {
//     let data = doc.data()
//     if (data.detTS >= lastWeek) {
//       list.push(data)
//     }
//   });
//   cb(list)
// }
export const getDataActive = async(coll, fieldName, fieldData , cb)=>{
  const q = query(collection(db, coll),
    where('active', '==', true), 
    where(fieldName, '==', fieldData),
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data()
  });
  cb(list)
}
export const matchTxsReqr = async(compId, cb)=>{
  const q = query(collection(db, "MatchTx"),
    where('active', '==', true), 
    where('compIdReqr', '==', compId),
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data()
  });
  cb(list)
}
export const matchTxsRels = async(compId, cb)=>{
  const q = query(collection(db, "MatchTx"),
    where('active', '==', true),
    where('compIdRels', '==', compId),
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data()
  });
  cb(list)
}

export const matchTxsTrans = async(compId, cb)=>{
  let list = []
  const q = query(collection(db, "MatchTx"),
    // where('detTS', '>=' , now),  
    // where('stepNo', 'in', [ 2 , 2.1 , 3 , 4]),      
    where('active', '==', true), 
    where('stepNo', 'in', [ 3 , 4]),  // after agent approved
    where('transCompId', '==', compId)
  );
  const querySnapshot = await getDocs(q);
  querySnapshot.docs.forEach((doc) => {
    let d = doc.data()
      list.push ({
        cust: d.jobTypeReqr == 'Pick-up' ? d.compNameLocalReqr : d.compNameLocalRels,
        ...d
      }) 
  });
  cb(list)
}
export const matchTxsAgent = async(agent, cb)=>{
  let lastWeek = Date.parse(new Date())-658800000
  let list = []
  const q = query(collection(db, "MatchTx"),
    // where('detTS', '>=' , now),   
    where('active', '==', true),
    where('stepNo', '==', 2),      
    where('agent', '==', agent)
  );
  const querySnapshot = await getDocs(q);
  querySnapshot.docs.forEach((doc) => {
    let data = doc.data()
    if (data.detTS >= lastWeek) {
      list.push ({
        actAgent:{
          cancel:false, 
          accept: true, 
          reject:true, 
          attachSeal:false,
          terminate:false,
          transfer:false,
        },
        ...data
      }) 
    }
  });
  cb(list)
}
export const makeMatchTxTrStep2 = async(mTxId , newBkgId)=>{
  const q = query(collection(db, "MatchTx"),  
    where('mTxId', '==', mTxId)
  );
  const querySnapshot = await getDocs(q);
  const mTx = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    Object.assign(d, {
      mTxId : d.mTxId + "TR",
      bkgId : newBkgId,
      jobTypeReqr : 'Transfer',
      jobTypeRels : 'Transfer',
      stepNo : 2,
      // status : "matched",
      actReqr:{
        cancel:false, 
        accept: false, 
        reject:false, 
        attachSeal:false,
        terminate:false,
        transfer:false,
      },  
      actRels:{
        cancel:false, 
        accept: false, 
        reject:false, 
        terminate:false,
      }, 
      jbReqr :  "waitApprovalTr",
      jbRels :  "waitApprovalTr",
      msReqr : 'transfer',
      msRels : 'transfer',

      txSearcher : "Transfer",
      timestamp : Date.parse(new Date())
    })
    return d
  });
  console.log(`[makeMatchTxTrStep2], mTx[0] =>  ${JSON.stringify(mTx[0], null, 2)}`)
  await setDoc(doc(db, "MatchTx", mTx[0].mTxId), mTx[0]);
}

export const mergeCSV = (collectionName, csvFile , cb)=>{
  // Read CSV data using PapaParse
  Papa.parse(csvFile, {
    header: true,
    complete: (results) => {
      // Upload data to Cloud Firestore
      results.data.forEach(async(item) => {
        // const docRef = await addDoc(collection(db, collectionName),item)
        const docRef1 = await setDoc(doc(db, collectionName, item.id),item, {merge:true});
          // console.log('Document written with ID:', docRef.id);
      });
    }
  });
  cb('success')
}
export const mergeObj = async(collection, id ,obj)=>{
  await setDoc(doc(db, collection, id),obj, {merge:true});
}
export const mTxIdReuByReuId= async(reuId, cb)=>{
  const q = query(collection(db, "MatchTx"), 
    where("reqrId", "==", reuId)
  );
  const querySnapshot = await getDocs(q);
  const m = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      mTxId : d.mTxId,
      msReqr : d.msReqr,
      msRels : d.msRels
    }
  })
  cb(m[0])
}
export const passwordResetEmail = async(email , cb)=>{ 
  await sendPasswordResetEmail(authUser, email).then(() => {
    cb( "success")
  }).catch((err) => {
    console.log(`resetPassword error code: ${err.code}`)
    cb (err.code)
  });
}
// export const postedByCompId = async(collectionName, compId, status, cb)=>{
//   const q = query(collection(db, collectionName),
//     where('compId', '==', compId),
//     where('status', '==', status), 
//   );
//   const querySnapshot = await getDocs(q);
//   const list = querySnapshot.docs.map((doc) => {
//       return doc.data()
//   });
//   cb(list)
// }
export const postedByAdmin = async(collectionName, status, cb)=>{
  const q = query(collection(db, collectionName),
    where('status', '==', status), 
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
      return doc.data()
  });
  cb(list)
}
export const saveWithId = async(collection, id , payload)=>{
  await setDoc(doc(db, collection, id), payload);
}
export const sealNoList = async(compId, cb)=>{
  const q = query(collection(db, "Seal"), 
    where("active", "==", true),
    where("compId", "==", compId)
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data().sealNo
  });
  cb(list)
}

// export const shoreAgentStartDate = async(agent,status ,sdTS ,cb)=>{
//   const s = query(collection(db, "Shore"),
//     where('agent', '==', agent),  
//     where('status', 'in', status),    
//     where('timestamp', '>=', sdTS),
//   );
//   const shoreSnapshot = await getDocs(s);
//   const list = shoreSnapshot.docs.map(async(doc) => {
//     return doc.data()
//   })
//   cb(list)
// }
// export const shoreCompIdStartDate = async(compId,status ,sdTS ,cb)=>{
//   const s = query(collection(db, "Shore"),
//     where('compId', '==', compId),  
//     where('status', 'in', status),    
//     where('timestamp', '>=', sdTS),
//   );
//   const shoreSnapshot = await getDocs(s);
//   const list = shoreSnapshot.docs.map(async(doc) => {
//     return doc.data()
//   })
//   cb(list)
// }
export const shoreAgentStartDate = async(agent,status ,sdTS ,cb)=>{
  let list = []
  const s = query(collection(db, "Shore"),
    where('agent', '==', agent),
    where('status', 'in', status),
  );
  const shoreSnapshot = await getDocs(s);
  shoreSnapshot.docs.forEach(async(doc) => {
    let shores = doc.data()
    if (shores.timestamp >= sdTS) {
      list.push(shores)
      } 
    })
  cb(list)
}
export const shoreCompIdStartDate = async(compId,status ,sdTS ,cb)=>{
  let list = []
  const s = query(collection(db, "Shore"),
    where('compId', '==', compId),
    where('status', 'in', status),
  );
  const shoreSnapshot = await getDocs(s);
  shoreSnapshot.docs.forEach(async(doc) => {
    let shores = doc.data()
    if (shores.timestamp >= sdTS) {
      list.push(shores)
      } 
    })
  cb(list)
}
export const sealNoListAgentGroup = async(compId, agent, cb)=>{
  await getAgentGroup(agent, async(agentGroup)=>{
    if (agentGroup == undefined) {
      cb([])
    } else {
          let list = []
    const q = query(collection(db, "Seal"), 
      where("active", "==", true),
      where("compId", "==", compId)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.docs.forEach((doc) => {
      let d = doc.data()
      if (agentGroup.includes(d.agent)){
        list.push(d.sealNo)
      }
    });
    cb(list)
    }
  })
}
export const sealNoListAll = async(compId, cb)=>{
  const q = query(collection(db, "Seal"), 
    where("active", "==", true),
    where("compId", "==", compId)
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data()
  });
  cb(list)
}
export const shipReviewByAgent= async(agent, startAt, endAt, cb)=>{
  const q = query(collection(db, "ShipReport"), 
    where('agent', '==', agent),  
    where('timestamp', '>=' , startAt),  
    where('timestamp', '<=' , endAt),  
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data()
  })
  cb(list)
}
export const shipReviewRemark= async(mTxId, cb)=>{
  const q = query(collection(db, "ShipReport"), 
    where('mTxId', '==', mTxId),    
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data().remark
  })
  cb(list[0])
}
export const slipComp = async(compId, startAt, endAt, cb)=>{
  console.log(`compId for slipComp =>${compId}`)
  const q = query(collection(db, "uaTx"),
    where('payerId', '==', compId),  
    where('timestamp', '>=' , startAt),  
    where('timestamp', '<=' , endAt),  
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      date : new Date(d.timestamp),
      ...d
    }
  })
  cb(list)
}
export const sumUpWallet =async(amount, compId) =>{
  console.log(`sumUpWallet, compId => ${compId}`)
  console.log(`sumUpWallet, amount => ${amount}`)
  if (!isNaN(amount)) {
    try {
      await updateDoc(doc(db, 'Wallet', compId), { 
        balanced: increment(amount),
        timestamp: new Date().valueOf()
      });
    } catch (e) {
        console.error("Error sumUp Wallet: ", e);
    } 
  }
}

export const transCompList = async(compId, cb)=>{
  let list = [
    {compId : compId, transName : "หัวรถบริษัทของคุณ / Company Track"} 
  ]
  const q = query(collection(db, "Company"), 
    where("active", "==", true),
    where("busType", "==", "trans"),
  );
  const querySnapshot = await getDocs(q);
  querySnapshot.docs.forEach((doc) => {
    let d = doc.data()
      list.push({compId : d.compId, transName : d.compNameLocal})
  });
  cb(list)
}
export const uaTxWallet = async( cost, compId, slipId, paymentMethod, acctType, reason ,remark)=>{
  await sumUpWallet(cost, compId)
  const uaTx = {
      slipId : slipId,
      payerId : compId,        
      paymentMethod : paymentMethod,
      amount : cost,
      acctType : acctType,
      reason : reason,
      remark : remark,
      timestamp : new Date().valueOf()
  }
  await saveWithId('uaTx', uaTx.slipId, uaTx)
}
export const updateActive= async(collection, id, state )=>{
  await updateDoc(doc(db, collection, id), { active: state});
}
export const updateContNo= async(collection, id, contNo )=>{
  await updateDoc(doc(db, collection, id), { contNo: contNo});
}
export const updateImageUri= async(collection, id, imageUri )=>{
  await updateDoc(doc(db, collection, id), { imageUri: imageUri});
}
export const updateTransStatusMatchTx= async(id, transStatus )=>{
  let ts = Date.parse(new Date())
  await updateDoc(doc(db, 'MatchTx', id), { 
    transStatus: transStatus,
    timestamp: ts
  });
  await saveWithId('transStatus' , `${id}-${ts}` , {
    id : id,
    transStatus : transStatus,
    timestamp : ts,
  })
}
export const updateTransStatusRels= async(collection, id, tsState , ts1State )=>{
  await updateDoc(doc(db, collection, id), { 
    transStatus: tsState,
    transStatus1: ts1State,
    timestamp: Date.parse(new Date())
  });
}
export const updateTransStatusRecv= async(collection, id, tsState , ts2State )=>{
  await updateDoc(doc(db, collection, id), { 
    transStatus: tsState,
    transStatus2: ts2State,
    timestamp: Date.parse(new Date())
  });
}
export const updateBookingTx2StepN= async(collection, id, stepN)=>{
  let obj = {}
  let ts = Date.parse(new Date())
  switch (stepN) {
    case 1.1:
      obj = {
        stepNo: 1.1,       
        jbBTx:"cancelCust",
        actCust:{
          cancel: false, 
          approve: false, 
          reject:false,
          editInfo : false,
          msgr : true,
          agentQ : false,
          agentB : false,
        },  
        actAgent:{
            accept: false, 
            reject:false,
            msgr : true,                        
            preQInfo : false,
            agentQ : false,
            agentB : false,
        },  
      }
      break;
    case 1.2:
      obj = {
        stepNo: 1.2,       
        jbBTx: "rejAgent",
        actCust:{
          cancel: false, 
          approve: false, 
          reject:false,
          editInfo : false,
          msgr : true,
          agentQ : false,
          agentB : false,
        },  
        actAgent:{
            accept: false, 
            reject:false,
            msgr : true,                        
            preQInfo : false,
            agentQ : false,
            agentB : false,
        },  
      }
      break;
    case 2:
      obj = {
        stepNo: 2,  
        jbBTx: "waitApproval",
        actCust:{
          cancel: false, 
          approve: true, 
          reject: true,
          editInfo : false,
          msgr : true,
          agentQ : true,
          agentB : false,
        },  
        actAgent:{
            accept: false, 
            reject:false,
            msgr : true,                        
            preQInfo : true,
            agentQ : true,
            agentB : false,
        },  
      }
      break;
    case 2.1:
      obj = {
        stepNo: 2.1,  
        jbBTx:'rejCust',
        actCust:{
          cancel: false, 
          approve: false, 
          reject: false,
          editInfo : false,
          msgr : true,
          agentQ : true,
          agentB : false,
        },  
        actAgent:{
            accept: false, 
            reject:false,
            msgr : true,                        
            preQInfo : true,
            agentQ : true,
            agentB : false,
        },  
      }
      break;
    case 3:
      obj = {
        stepNo: 3,         
        jbBTx:'approved',
        actCust:{
          cancel: false, 
          approve: false, 
          reject: false,
          editInfo : false,
          msgr : true,
          agentQ : true,
          agentB : false,
        },  
        actAgent:{
            accept: false, 
            reject:false,
            msgr : true,                        
            preQInfo : true,
            agentQ : true,
            agentB : true,
        },  
      }
      break;
    case 4:
      obj = {
        stepNo: 4,         
        jbBTx:'completed',
        actCust:{
          cancel: false, 
          approve: false, 
          reject: false,
          editInfo : false,
          msgr : true,
          agentQ : true,
          agentB : true,
        },  
        actAgent:{
            accept: false, 
            reject:false,
            msgr : true,                        
            preQInfo : true,
            agentQ : true,
            agentB : true,
        },  
      }
      break;
    default:
      break;
  }
  await setDoc(doc(db, collection, id),obj, {merge:true});
  await saveWithId('jbBTx' , `${id}-${ts}` , {
    id : id,
    jbBTx : obj.jbBTx,
    timestamp : ts,
  })
}
export const updateMatchTx2StepN= async(collection, id, stepN , sealNo = '')=>{
  let obj
  let ts = Date.parse(new Date())
  switch (stepN) {
    case 1.1:
      obj = {
        stepNo: 1.1,       
        msReqr: "cancel",
        jbReqr:"cancelReqr",
        actReqr:{
          cancel:false, 
          accept: false, 
          reject:false, 
          attachSeal:false,
          terminate:false,
          transfer:false,
        },  
        actRels:{
          cancel:false, 
          accept: false, 
          reject:false, 
        },
        msRels: "cancel",    
        jbRels:"cancelReqr",
        shoreStatus: "cancel",
        transStatus: "cancel"
      }
      break;
    case 1.2:
      obj = {
        stepNo: 1.2,       
        msReqr: "reject",
        jbReqr: "rejectReqr",
        actReqr:{
          cancel:false, 
          accept: false, 
          reject:false, 
          attachSeal:false,
          terminate:false,
          transfer:false,
        },  
        actRels:{
          cancel:false, 
          accept: false, 
          reject:false, 
        },
        msRels: "reject",
        jbRels:"rejectReqr",
        shoreStatus: "cancel",
        transStatus: "cancel"
      }
      break;
    case 1.3:
      obj = {
        stepNo: 1.3,       
        msReqr: "cancel",
        jbReqr:"cancelRels",
        actReqr:{
          cancel:false, 
          accept: false, 
          reject:false, 
          attachSeal:false,
          terminate:false,
          transfer:false,
        },  
        actRels:{
          cancel:false, 
          accept: false, 
          reject:false, 
        },
        msRels: "cancel",  
        jbRels:"cancelRels",
        shoreStatus: "cancel",
        transStatus: "cancel"
      }
      break;
    case 1.4:
      obj = {
        stepNo: 1.4,       
        msReqr: "reject",
        jbReqr: "rejectRels",
        actReqr:{
          cancel:false, 
          accept: false, 
          reject:false, 
          attachSeal:false,
          terminate:false,
          transfer:false,
        },  
        actRels:{
          cancel:false, 
          accept: false, 
          reject:false, 
        },
        msRels: "reject",   
        jbRels:"rejectRels",
        shoreStatus: "cancel",
        transStatus: "cancel"
      }
      break;
    case 2:
      obj = {
        stepNo: 2,  
        msReqr: 'matched',
        jbReqr:"waitApproval",
        actReqr:{
          cancel:false, 
          accept: false, 
          reject:false, 
          attachSeal:false,
          terminate:false,
          transfer:false,
        },  
        actRels:{
          cancel:false, 
          accept: false, 
          reject:false, 
        },   
        msRels: 'matched',                     
        jbRels:'waitApproval',
      }
      break;
    case 2.1:
      obj = {
        stepNo: 2.1,  
        msReqr: 'reject',
        jbReqr:'shipsRej',
        actReqr:{
          cancel:false, 
          accept: false, 
          reject:false, 
          attachSeal:false,
          terminate:false,
          transfer:false,
        },  
        actRels:{
          cancel:false, 
          accept: false, 
          reject:false, 
        },   
        msRels: 'approved',  
        jbRels:'shipsRej',
        shoreStatus: "cancel",
        transStatus: "cancel",
      }
      break;
    case 3:
      obj = {
        stepNo: 3,         
        msReqr: 'approved',
        jbReqr: 'activeTrans',
        actReqr:{
          cancel:false, 
          accept: false, 
          reject:false, 
          attachSeal:true,
          terminate:true,
          transfer:false,
          eirRels:false,
          eirRecv:false,
          dispRels: false,
          dispRecv: false,
          shore: false,
        },  
        actRels:{
          cancel:false, 
          accept: false, 
          reject:false, 
          eirRels:false,
          eirRecv:false,          
          dispRels: false,
        },
        msRels: 'approved',                                   
        jbRels: 'activeTrans',
      }
      break;
    case 4:
      obj = {
        stepNo: 4,         
        msReqr: 'approved',
        jbReqr:'waitDisp-1',
        actReqr:{
          cancel:false, 
          accept: false, 
          reject:false, 
          attachSeal:false,
          terminate:false,
          transfer:false,
          eirRels:true,
          eirRecv:false,
          dispRels: true,  
          dispRecv: false,          
          shore: false,
          updateSeal:true
        },  
        actRels:{
          cancel:false, 
          accept: false, 
          reject:false, 
          eirRels:true,
          eirRecv:false,
          dispRels: true,
        },
        msRels: 'approved',                                     
        jbRels: 'waitDisp-1',
        timestamp: Date.parse(new Date()),
        sealNo : sealNo 
      }
      break;
    case 4.1:
      obj = {
        stepNo: 4.1,         
        msReqr: 'cancel',
        jbReqr:'rejectDisp-1',
        actReqr:{
          cancel:false, 
          accept: false, 
          reject:false, 
          attachSeal:false,
          terminate:false,
          transfer:false,
          eirRels:true,
          eirRecv:false,
          dispRels: false,     
          dispRecv: false,          
          shore: false,
          updateSeal:false
        },  
        actRels:{
          cancel:false, 
          accept: false, 
          reject:false, 

          eirRels:true,
          eirRecv:false,
          dispRels: false,
        },
        msRels: 'cancel',                                      
        jbRels: 'rejectDisp-1',
        shoreStatus: "cancel",
        transStatus: "rejRels",
        timestamp: ts,
      }
      break;
    case 4.2:
      obj = {
        stepNo: 4.2,         
        msReqr: 'terminated',
        jbReqr:'terminated',
        actReqr:{
          cancel:false, 
          accept: false, 
          reject:false, 
          attachSeal:false,
          terminate:false,
          transfer:false,
          updateSeal:false,
          dispRecv: false,
        },  
        actRels:{
          cancel:false, 
          accept: false, 
          reject:false, 
          dispRels: false,
        },
        msRels: 'terminated',                                      
        jbRels: 'terminated',
        timestamp: ts,
        shoreStatus: "cancel",
        transStatus: "cancel"
      }
      break;
    case 5:
      obj = {
        stepNo: 5,         
        msReqr: 'approved',
        jbReqr:'waitDisp-2',
        actReqr:{
          cancel:false, 
          accept: false, 
          reject:false, 
          attachSeal:false,
          terminate:false,
          transfer:false,
          eirRels:true,
          eirRecv:true,
          dispRels: false,  
          dispRecv: true,          
          shore: false,
          updateSeal:true
        },  
        actRels:{
          cancel:false, 
          accept: false, 
          reject:false, 
          eirRels:true,
          eirRecv:true,
          dispRels: false,
        },
        msRels: 'approved',                                     
        jbRels: 'waitDisp-2',
        transStatus: "doneRels",
        timestamp: Date.parse(new Date()),
      }
      break;  
    case 5.1:
      obj = {
        stepNo: 5.1,         
        msReqr: 'cancel',
        jbReqr:'rejectDisp-2',
        actReqr:{
          cancel:false, 
          accept: false, 
          reject:false, 
          attachSeal:false,
          terminate:false,
          transfer:false,
          eirRels:true,
          eirRecv:true,
          dispRels: false,     
          dispRecv: false,          
          shore: false,
          updateSeal:false
        },  
        actRels:{
          cancel:false, 
          accept: false, 
          reject:false, 
          eirRels:true,
          eirRecv:true,
          dispRels: false,
        },
        msRels: 'cancel',                                      
        jbRels: 'rejectDisp-2',
        shoreStatus: "cancel",
        transStatus: "rejRecv",
        timestamp: ts,
      }
      break;
    case 6:
      obj = {
        stepNo: 6,         
        msReqr: 'completed',
        jbReqr:'completedDisp',
        actReqr:{
          cancel:false, 
          accept: false, 
          reject:false, 
          attachSeal:false,
          terminate:false,
          transfer:true,
          eirRels:true,
          eirRecv:true,
          dispRels: false,  
          dispRecv: false,          
          shore: true,
          updateSeal:true
        },  
        actRels:{
          cancel:false, 
          accept: false, 
          reject:false, 
          eirRels:true,
          eirRecv:true,
          dispRels: false,
        },
        msRels: 'completed',                                     
        jbRels: 'completedDisp',
        transStatus: "finish",
        timestamp: ts,
      }
      break;  
    case 6.1:
      obj = {
        stepNo: 6.1,         
        msReqr: 'transferred',
        jbReqr:'transferred',
        actReqr:{
          cancel:false, 
          accept: false, 
          reject:false, 
          attachSeal:false,
          terminate:false,
          transfer:false,
          eirRels:true,
          eirRecv:true,
          dispRels: false,
          dispRecv: false,  
          shore: false,
          updateSeal:false
        },  
        actRels:{
          cancel:false, 
          accept: false, 
          reject:false, 
          eirRels:true,
          eirRecv:true,
          dispRels: false,
        },
        msRels: 'transferred',                                     
        jbRels: 'transferred',
        timestamp: ts,
        shoreStatus: "cancel",
        transStatus: "finishTfd"
      }
      break;
    case 7:
      obj = {
        stepNo: 7,         
        msReqr: 'completed',
        jbReqr:'completedEnd',
        actReqr:{
          cancel:false, 
          accept: false, 
          reject:false, 
          attachSeal:false,
          terminate:false,
          transfer:false,
          eirRels:true,
          eirRecv:true,
          dispRels: false,  
          dispRecv: false,          
          shore: false,
          updateSeal:false
        },  
        actRels:{
          cancel:false, 
          accept: false, 
          reject:false, 
          eirRels:true,
          eirRecv:true,
          dispRels: false,
        },
        msRels: 'completed',                                     
        jbRels: 'completedEnd',
        timestamp: ts,
        shoreStatus: "waitAccept",
        transStatus: "completed"
      }
      break;  
    default:
      break;
  }
  // console.log(`data=> ${JSON.stringify(obj , null , 2)}`)
  // await updateDoc(doc(db, collection, id), obj);
  await setDoc(doc(db, collection, id),obj, {merge:true});
  await saveWithId('jbStatusReqr' , `${id}-${ts}` , {
    id : id,
    jbReqr : obj.jbReqr,
    timestamp : ts,
  })
  await saveWithId('jbStatusRels' , `${id}-${ts}` , {
    id : id,
    jbRels : obj.jbRels,
    timestamp : ts,
  })
  if (obj.transStatus) {
    await saveWithId('transStatus' , `${id}-${ts}` , {
      id : id,
      transStatus : obj.transStatus,
      timestamp : ts,
    })      
  }

}
export const updateSealNo= async(collection, id , sealNo)=>{
  await updateDoc(doc(db, collection, id), { sealNo: sealNo});
}
export const updateStatus= async(collection, id, status )=>{
  await updateDoc(doc(db, collection, id), { status: status});
}

export const uploadImage = async( bucket, fileURL , cb)=>{
  const file = await getPictureBlob(fileURL.url)
  const storageRef = ref(storage, `${bucket}/${fileURL.name}`)
  await uploadBytes(storageRef , file)
  .then(async(snapshot)=>{
    // console.log(`snapshot => ${JSON.stringify(snapshot , null ,2)}`)
    await getDownloadURL(storageRef)
    .then((url)=>{
      cb(url)
    })
  })
}

export const userInfoByUserId= async(userId, cb)=>{
  const q = query(collection(db, "Users"), 
  where("active", "==", true), 
  where("userId", "==", userId)
  );
  const querySnapshot = await getDocs(q);
  const user = querySnapshot.docs.map((doc) => {
    return doc.data()
  })
  cb(user[0])
}
export const userInfoByUid= async(uid, cb)=>{
  const q = query(collection(db, "Users"), 
  where("uid", "==", uid)
  );
  const querySnapshot = await getDocs(q);
  const user = querySnapshot.docs.map((doc) => {
    return doc.data()
  })
  cb(user[0])
}
export const userListAll = async(cb)=>{
  const q = query(collection(db, "Users")
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    return doc.data()
  });
  cb(list)
}
// export const verifyExstContNo = async(contNo , cb)=>{
//   let lastMonth = Date.parse(new Date())-2635200000
//   const q = query(collection(db, "Container"), 
//   where("contNo", "==", contNo),
//   where("detTS", ">=", lastMonth)
//   );
//   const querySnapshot = await getDocs(q);
//   const contId = querySnapshot.docs.map((doc) => {
//     return doc.data().contId
//   })
//   cb(contId[0])
// }
export const xlsxInternal = async(compId, startAt, endAt, cb)=>{
  const q = query(collection(db, "MatchTx"),
    where('stepNo', 'in', [ 4, 4.1, 4.2]), 
    where('txSearcher', '==', "Reuse"), 
    where('compIdReqr', '==', compId),  
    where('timestamp', '>=' , startAt),  
    where('timestamp', '<=' , endAt),  
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      เลขที่จับคู่: d.mTxId,
      วันที่บันทึก: new Date(d.timestamp),
      ประเภทงาน : `${d.txSearcher}-Reuse`,
      เลขจอง: d.bkgId, 
      เลขซีล: d.sealNo, 
      เลขตู้: d.contNo,
      วันกำหนดคืนตู้: d.detDate,      
      ชนิดตู้: d.contType,
      ขนาดตู้: d.contSize,
      เกรดตู้: d.contGrade,
      สายเรือ: d.agent,                
      ผู้ให้: d.compNameLocalRels,               
      ที่อยู่ส่ง: d.contRelsAddress,          
      ผู้รับ: d.compNameLocalReqr,                
      ที่อยู่รับ: d.contReqrAddress,
      สถานะการจับคู่: d.msReqr,
      สถานะงาน: d.jbReqr
    }
  });
  cb(list)
}
export const xlsxPropsr = async(compId, startAt, endAt, cb)=>{
  const q = query(collection(db, "MatchTx"),
    where('stepNo', 'in', [ 4, 4.1, 4.2]), 
    where('txSearcher', 'in', ["Require", "Release"]), 
    where('compIdRels', '==', compId),  
    where('timestamp', '>=' , startAt),  
    where('timestamp', '<=' , endAt),  
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      เลขที่จับคู่: d.mTxId,
      วันที่บันทึก: new Date(d.timestamp),
      ประเภทงาน : `${d.txSearcher}-Proposer`,
      เลขจอง: d.bkgId, 
      เลขซีล: d.sealNo, 
      เลขตู้: d.contNo,
      วันกำหนดคืนตู้: d.detDate,      
      ชนิดตู้: d.contType,
      ขนาดตู้: d.contSize,
      เกรดตู้: d.contGrade,
      สายเรือ: d.agent,                
      ผู้ให้: d.compNameLocalRels,               
      ที่อยู่ส่ง: d.contRelsAddress,          
      ผู้รับ: d.compNameLocalReqr,                
      ที่อยู่รับ: d.contReqrAddress,
      สถานะการจับคู่: d.msReqr,
      สถานะงาน: d.jbReqr
    }
  });
  cb(list)
}
export const xlsxRecvr = async(compId, startAt, endAt, cb)=>{
  const q = query(collection(db, "MatchTx"),
    where('stepNo', 'in', [ 4, 4.1, 4.2]), 
    where('txSearcher', 'in', ["Require", "Release"]), 
    where('compIdReqr', '==', compId),  
    where('timestamp', '>=' , startAt),  
    where('timestamp', '<=' , endAt),  
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      เลขที่จับคู่: d.mTxId,
      วันที่บันทึก: new Date(d.timestamp),
      ประเภทงาน : `${d.txSearcher}-Receiver`,
      เลขจอง: d.bkgId, 
      เลขซีล: d.sealNo, 
      เลขตู้: d.contNo,
      วันกำหนดคืนตู้: d.detDate,      
      ชนิดตู้: d.contType,
      ขนาดตู้: d.contSize,
      เกรดตู้: d.contGrade,
      สายเรือ: d.agent,                
      ผู้ให้: d.compNameLocalRels,               
      ที่อยู่ส่ง: d.contRelsAddress,          
      ผู้รับ: d.compNameLocalReqr,                
      ที่อยู่รับ: d.contReqrAddress,
      สถานะการจับคู่: d.msReqr,
      สถานะงาน: d.jbReqr
    }
  });
  cb(list)
}
export const xlsxTransfer = async(compId, startAt, endAt, cb)=>{
  const q = query(collection(db, "MatchTx"),
    where('stepNo', 'in', [ 4, 4.1, 4.2]), 
    where('txSearcher', '==', "Transfer"), 
    where('compIdReqr', '==', compId),  
    where('timestamp', '>=' , startAt),  
    where('timestamp', '<=' , endAt),  
  );
  const querySnapshot = await getDocs(q);
  const list = querySnapshot.docs.map((doc) => {
    let d = doc.data()
    return {
      เลขที่จับคู่: d.mTxId,
      วันที่บันทึก: new Date(d.timestamp),
      ประเภทงาน : 'Transfer',
      เลขจอง: d.bkgId, 
      เลขซีล: d.sealNo, 
      เลขตู้: d.contNo,
      วันกำหนดคืนตู้: d.detDate,      
      ชนิดตู้: d.contType,
      ขนาดตู้: d.contSize,
      เกรดตู้: d.contGrade,
      สายเรือ: d.agent,                
      ผู้ให้: d.compNameLocalRels,               
      ที่อยู่ส่ง: d.contRelsAddress,          
      ผู้รับ: d.compNameLocalReqr,                
      ที่อยู่รับ: d.contReqrAddress,
      สถานะการจับคู่: d.msReqr,
      สถานะงาน: d.jbReqr
    }
  });
  cb(list)
}













